import { useState, useEffect } from "react";

interface ResetDataToExport<T, U> {
  data: T[];
  deps: U[];
}

/**
 * This hook should be used along with the ExcelExporter component
 * to prevent exported file duplication.
 * It simply resets the data if one of the provided deps changed.
 * It can be omitted if no state changes are expected.
 */
export const useResetDataToExport = <T, U>({ data, deps}: ResetDataToExport<T, U>) => {
  const [isResetDataToExport, setResetDataToExport] = useState(false);

  const dataToExport = !isResetDataToExport ? data : undefined;

  useEffect(() => {
    setResetDataToExport(true);
  }, [...deps]); // eslint-disable-line react-hooks/exhaustive-deps

  return { dataToExport, setResetDataToExport };
};
